import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import DescriptionIcon from "@mui/icons-material/Description";
import UndoIcon from "@mui/icons-material/Undo";
import DoneIcon from "@mui/icons-material/Done";
import Typography from "@mui/material/Typography";
import StyleTooltip from "helpers/StyleTooltip";
import { Link } from "react-router-dom";
import { sendClientCommand } from "helpers/functions/clientCommand";
import { DocumentLockGet } from "entities/generated/back/data-contracts";
import { useNotification } from "shared/hooks";
import { apiDocuments } from "app/axios";

interface IDockLock {
  closePopover: () => void;
}

const DockLock = (props: IDockLock) => {
  const { t } = useTranslation("shared");
  const { closePopover } = props;
  const { showNotify } = useNotification();

  const [LockDock, setLockDock] = useState<DocumentLockGet[]>([]);

  async function UpdateDockLock() {
    apiDocuments
      .getLock({ filterPageNumber: 0, filterSizePage: 10 })
      .then((response) => setLockDock(response.data.items))
      .catch((error) => showNotify(error.message, "error"));
  }

  useEffect(() => {
    UpdateDockLock();
  }, []);

  const RenderItem = (lock: any) => {
    const doc = lock.lock.document;
    return (
      <ListItem>
        <Link
          style={{ padding: 0 }}
          onClick={closePopover}
          to={{
            pathname: `/documents`,
            state: {
              documentId: doc.documentId,
              categoryId: doc.categoryId,
            },
          }}
        >
          <ListItemAvatar>
            <Avatar>
              <DescriptionIcon />
            </Avatar>
          </ListItemAvatar>
        </Link>
        <ListItemText primary={lock.lock.document.name} />
        <ListItemSecondaryAction>
          <StyleTooltip text={t("dropmenu.undo")}>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => {
                closePopover();
                sendClientCommand(`undo/${lock.lock.id}`);
              }}
            >
              <UndoIcon />
            </IconButton>
          </StyleTooltip>
          <StyleTooltip text={t("dropmenu.commit")}>
            <IconButton
              edge="end"
              aria-label="save"
              onClick={() => {
                closePopover();
                sendClientCommand(`commit/${lock.lock.id}`);
              }}
            >
              <DoneIcon />
            </IconButton>
          </StyleTooltip>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  return (
    <div>
      <List>
        {Array.isArray(LockDock) &&
          LockDock.map((lock: any) => {
            return <RenderItem lock={lock} key={lock.id} />;
          })}

        {LockDock.length === 0 && (
          <ListItem alignItems="center">
            <Typography>{t("dropmenu.emptyLock")}</Typography>
          </ListItem>
        )}
      </List>
    </div>
  );
};
export default DockLock;
